"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const Node_1 = require("./Node");
class Rule {
    constructor(lhs, rhs, condition) {
        this.lhs = lhs;
        this.rhs = rhs;
        this.condition = condition;
    }
    static matchNodes(one, other, matches = immutable_1.Map()) {
        if (one instanceof Node_1.Rewritable) {
            if (!matches.get(one.toString(), other).equals(other)) {
                throw Error('No match');
            }
            return matches.set(one.toString(), other);
        }
        if (one.constructor !== other.constructor || one.value !== other.value) {
            throw Error('No match');
        }
        if (one instanceof Node_1.Operator &&
            other instanceof Node_1.Operator &&
            one.children.size === other.children.size) {
            return one.children.reduce((matches, child, index) => Rule.matchNodes(child, other.children.get(index, child), matches), matches);
        }
        return matches;
    }
    matches(other) {
        try {
            const matches = Rule.matchNodes(this.lhs, other);
            if (this.condition &&
                this.condition
                    .rewrite(matches)
                    .evaluate()
                    .equals(Node_1.FALSE)) {
                throw Error('No match - false condition');
            }
            return matches;
        }
        catch (_a) {
            return immutable_1.Map();
        }
    }
    equals(other) {
        return (this.constructor === other.constructor &&
            Object.entries(this).every(([key, value]) => value instanceof Node_1.default ? value.equals(other[key]) : value === other[key]));
    }
    toString() {
        const equation = `${this.lhs}=${this.rhs}`;
        return this.condition === undefined ? equation : `${equation} if ${this.condition}`;
    }
    execute(namespace) {
        return {
            namespace: namespace,
            stdOut: this.toString(),
        };
    }
}
exports.default = Rule;
//# sourceMappingURL=Rule.js.map